import { Serializers, SerializerValue } from "@megaron/serializers";

export const customerCategories = ["loyaltyUser", "pos", "payer", "distributor", "chain"] as const;
export type CustomerCategory = (typeof customerCategories)[number];

export const customerStatuses = ["vip", "verified", "unverified", "inactive"] as const;
export type CustomerStatus = (typeof customerStatuses)[number];

export const relationTypes = ["invitedBy", "supplyPoint", "chain", "payer", "distributor"] as const;
export type RelationType = (typeof relationTypes)[number];

export const customerSortFields = [
  "name",
  "totalMassKg",
  "lastInteractionTime",
  "lastVisitTime",
  "lastPurchaseTime",
  "invitedChildrenCount",
  "supplyPointChildrenCount",
  "payerChildrenCount",
  "distributorChildrenCount",
  "chainChildrenCount",
] as const;
export type CustomerSortField = (typeof customerSortFields)[number];

export const customerPresetFiltersSerializer = Serializers.object({
  sort: Serializers.sortFilter(customerSortFields),
  isPro: Serializers.boolean,
  isAffiliate: Serializers.boolean,
  isActive: Serializers.boolean,
  hasGooglePlaceId: Serializers.boolean,
  pos: Serializers.string.array(),
  scannedProducts: Serializers.string.array(),
  tags: Serializers.string.array(),
  isMyRegion: Serializers.boolean,
  regions: Serializers.string.array(),
  isUnassigned: Serializers.boolean,
  status: Serializers.stringOneOf(...customerStatuses).array(),
  categories: Serializers.stringOneOf(...customerCategories).array(),
  parents: Serializers.string.array(),
  relation: Serializers.object({
    relationType: Serializers.stringOneOf(...relationTypes),
    parents: Serializers.string.array(),
  }),
  loyaltyJoinedAtStartDate: Serializers.dateOnly,
  loyaltyJoinedAtEndDate: Serializers.dateOnly,
}).partial();

export type CustomerPresetFilters = SerializerValue<typeof customerPresetFiltersSerializer>;

export const customerFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  searchText: Serializers.string,
  ...customerPresetFiltersSerializer.fields,
}).partial();

export type CustomerFilters = SerializerValue<typeof customerFiltersSerializer>;
